const data = {
    "projects": {
        "personal": [
            {
                "title": "Maxi's Gallery",
                "desc": "Built from scratch using Headless Wordpress with NextJS, Tailwind CSS and GraphQL.",
                "image": "maxis-gallery.JPG",
                "link": "https://maxis-gallery.joanah.xyz/",
                "git": ""
            },
            {
                "title": "Cup Notes",
                "desc": "Built from scratch using React and Prisma",
                "image": "cupnotes.jpg",
                "link": "https://cup-notes.joanah.xyz/",
                "git": ""
            },
            {
                "title": "Fate Grand Order Servant Preview List",
                "desc": "Built from scratch using React, Vite, Typescript and Chakra UI.",
                "image": "fgo-prev.JPG",
                "link": "https://fgo-servant-list.vercel.app/",
                "git": "https://github.com/joanah09/fgo-servant-list"
            },
            {
                "title": "Todo List",
                "desc": "Built from scratch using React and Vite.",
                "image": "todo.jpg",
                "link": "https://todo-one-red.vercel.app/",
                "git": "https://github.com/joanah09/todo"
            },
            {
                "title": "Branding",
                "desc": "Built from scratch using Reactjs and Tailwind CSS.",
                "image": "branding.jpg",
                "link": "https://branding-beta.vercel.app/",
                "git": "https://github.com/joanah09/branding"
            },
            {
                "title": "Tech Support",
                "desc": "Built from scratch, used react-bootstrap and react-parallax.",
                "image": "tech-support.jpg",
                "link": "https://tech-support.vercel.app/",
                "git": "https://github.com/joanah09/tech-support"
            },
            {
                "title": "DBC Clone",
                "desc": "A wordpress website, converted to ReactJS.",
                "image": "dbc.jpg",
                "link": "https://dbc-clone.vercel.app/",
                "git": "https://github.com/joanah09/dbc-clone"
            }
        ],
        "content": [
            {
                "title": "Xpert Tinting",
                "desc": "One of my projects in Futurelab Digital, created with Wordpress Gutenberg.",
                "image": "xpert.JPG",
                "link": "https://xperttinting.co.nz/",
                "git": ""
            },
            {
                "title": "FAB CMS",
                "desc": "One of my projects in Futurelab Digital, created with Wordpress Gutenberg.",
                "image": "fab.JPG",
                "link": "https://fabtcg.com/",
                "git": ""
            },
            {
                "title": "FAB Cardvault",
                "desc": "One of my projects in Futurelab Digital, created with ReactJS and Tailwind CSS.",
                "image": "fabdb.JPG",
                "link": "https://cardvault.fabtcg.com/",
                "git": ""
            },
            {
                "title": "Profitability Partners",
                "desc": "Previous freelance project using Elementor.",
                "image": "profitability.JPG",
                "link": "https://profitabilitypartners.com.au/",
                "git": ""
            },
            {
                "title": "Isla Source",
                "desc": "Previous freelance project using Elementor.",
                "image": "isla-source.JPG",
                "link": "https://islasource.com/",
                "git": ""
            },
            {
                "title": "Everest Cryo",
                "desc": "One of my previous Shopify project on Project Assistant.",
                "image": "everestcryo.jpg",
                "link": "https://everestcryo.com/",
                "git": ""
            },
            {
                "title": "KJ Catering",
                "desc": "One of my previous Wordpress project on Project Assistant.",
                "image": "kjcatering.jpg",
                "link": "https://k-jcatering.com/",
                "git": ""
            },
            {
                "title": "Project Assistant",
                "desc": "One of my maintained project using Headless Wordpress with NextJS in Project Assistant.",
                "image": "PA.jpg",
                "link": "https://www.projectassistant.org/",
                "git": ""
            },
            {
                "title": "Ceres Organics",
                "desc": "One of my previously maintained shopify project in Moustache Republic.",
                "image": "ceres.jpg",
                "link": "https://ceres.co.nz/",
                "git": ""
            },
            {
                "title": "Bondi Sands",
                "desc": "One of the shopify project I previously maintained and worked on Moustache Republic.",
                "image": "bondi.jpg",
                "link": "https://bondisands.eu/pages/technoverse",
                "git": ""
            },
            {
                "title": "Simply for strings",
                "desc": "One of the shopify project I previously maintained and worked on Moustache Republic.",
                "image": "simply.jpg",
                "link": "https://www.simplyforstrings.com.au/",
                "git": ""
            },
            {
                "title": "Rebecca Vallance",
                "desc": "One of the shopify project I previously maintained and worked on Moustache Republic.",
                "image": "rvr.jpg",
                "link": "https://rebeccavallance.com/",
                "git": ""
            },
            {
                "title": "Eve Wellness",
                "desc": "One of my previously maintained shopify project in Moustache Republic.",
                "image": "eve.jpg",
                "link": "https://evewellness.com/",
                "git": ""
            },
            {
                "title": "Conveyancing",
                "desc": "One of my previously maintained wordpress project in Deepblue Company.",
                "image": "conveyancing.jpg",
                "link": "https://conveyancing.com.au/",
                "git": ""
            },
            {
                "title": "Rapid Building Inspections",
                "desc": "One of my previously maintained wordpress project in Deepblue Company.",
                "image": "rbi.jpg",
                "link": "https://www.rapidbuildinginspections.com.au/",
                "git": ""
            },
            {
                "title": "Offer to Own",
                "desc": "One of my previously maintained laravel project in Deepblue Company.",
                "image": "offertoown.jpg",
                "link": "https://offertoown.com.au/",
                "git": ""
            },
            {
                "title": "California Paramedic",
                "desc": "One of my projects back in 2017, created with Laravel in Dog and Rooster.",
                "image": "caparamedic.jpg",
                "link": "https://caparamedic.org/",
                "git": ""
            } 
        ]
    },
    "about": {
        "info": {
            "title": "Joanah Osorio",
            "position": "Frontend Web Developer",
            "desc": "Experienced in Shopify, WordPress, React, and Next.js. I build and maintain responsive websites with clean, user-friendly interfaces.",
            "links": [
                {
                    "name": "HTML",
                    "image": "fa-brands fa-html5"
                },
                {
                    "name": "CSS",
                    "image": "fa-brands fa-css3-alt"
                },
                {
                    "name": "Sass",
                    "image": "fa-brands fa-sass"
                },
                {
                    "name": "Javascript",
                    "image": "fa-brands fa-js"
                },
                {
                    "name": "Typescript",
                    "image": "logo-typescript"
                },
                {
                    "name": "jQuery",
                    "image": "logo-jquery"
                },
                {
                    "name": "Bootstrap",
                    "image": "fa-brands fa-bootstrap"
                },
                {
                    "name": "Tailwind",
                    "image": "logo-tailwind"
                },
                {
                    "name": "Shopify",
                    "image": "fa-brands fa-shopify"
                },
                {
                    "name": "ReactJS",
                    "image": "fa-brands fa-react"
                },
                {
                    "name": "NextJS",
                    "image": "logo-nextjs"
                },
                {
                    "name": "Elementor",
                    "image": "fa-brands fa-elementor"
                },
                {
                    "name": "WordPress",
                    "image": "fa-brands fa-wordpress"
                },
                {
                    "name": "Laravel",
                    "image": "fa-brands fa-laravel"
                },
                {
                    "name": "Source Tree",
                    "image": "fa-brands fa-sourcetree"
                },
                {
                    "name": "Git",
                    "image": "fa-brands fa-git-alt"
                },
                {
                    "name": "Claude Code",
                    "image": "logo-claude"
                },
                {
                    "name": "Codex",
                    "image": "logo-codex"
                }
            ],
            "others": [
                {   "name": "Github",
                    "image": "fa-brands fa-github",
                    "link": "https://github.com/joanah09"
                },
                {   "name": "Linkedin",
                    "image": "fa-brands fa-linkedin",
                    "link": "https://www.linkedin.com/in/joanah-osorio/"
                },
                {   "name": "Gmail",
                    "image": "fa fa-envelope",
                    "link": "mailto:joanah009@gmail.com"
                }
            ]
        },   
    },
    "resume": {
        "info": {
            "name": "Joanah Osorio",
            "position": "Frontend Developer",
            "cv": `../../assets/others/Resume - Joanah Osorio.pdf`,
            "about": [
                {
                    "location": "Las Piñas, Philippines",
                    "phone": "0956 5233 757",
                    "gmail": "joanah009@gmail.com",
                    "linkedin": "https://www.linkedin.com/in/joanah-osorio/",
                    "github": "https://github.com/joanah09"
                }
            ],
            "skills": [
                {
                    "title": "Languages",
                    "skill_list": [
                        "HTML",
                        "CSS",
                        "Javascript"
                    ]
                },
                {
                    "title": "Framework/Library",
                    "skill_list": [
                        "Elementor",
                        "Bootstrap",
                        "Tailwind",
                        "Sass",
                        "jQuery",
                        "ReactJs / NextJs",
                        "Laravel"
                    ]
                },
                {
                    "title": "CMS",
                    "skill_list": [
                        "Shopify",
                        "Wordpress"
                    ]
                },
                {
                    "title": "Tools Used",
                    "skill_list": [
                        "Claude Code",
                        "Codex",
                        "VSCode",
                        "Git",
                        "Bitbucket",
                        "Figma"
                    ]
                }
            ],
            "education": [
                {
                    "course": "Bachelor of Science Information Technology",
                    "school": `AMA Computer College Las Piñas,
                    Philippines`,
                    "location": `Alabang Zapote Road, Almanza, Las Piñas`,
                    "sy": "2008 – 2012"
                }
            ],
            "experience": [
                {
                    "company": "Futurtelab Digital",
                    "position": "Frontend Developer",
                    "location": "Remote",
                    "year": "November 2024 - Present",
                    "responsibility": [
                        "Create websites from scratch using Wordpress Gutenberg.",
                        "Maintained a Wordpress Gutenberg website.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "Project Assistant",
                    "position": "Frontend Developer",
                    "location": "Remote",
                    "year": "February 2024 - Present",
                    "responsibility": [
                        "Maintained and developed a website using Headless Wordpress with NextJs.",
                        "Used GraphQL for data queries for Headless Wordpress, Sass and Tailwind for website styling, Motion framer for animation.",
                        "Maintained a Wordpress Gutenberg website.",
                        "Also maintained a Wordpress website using Elementor/Kadence theme.",
                        "Developing and maintaining Shopify based websites.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "Filta Global (Moustache Republic)",
                    "position": "Frontend Developer",
                    "location": "Remote",
                    "year": "August 2022 - October 2023",
                    "responsibility": [
                        "Followed agile methods for better project efficiency",
                        "Migrating old Shopify templates to Shopify 2.0",
                        "Developing and maintaining Shopify based websites.",
                        "Implemented mobile responsive using Sass.",
                        "Maintained and added new features for several BigCommerce projects.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "Deep Blue Company",
                    "position": "Frontend Developer",
                    "location": "Remote",
                    "year": "November 2019 - July 2022",
                    "responsibility": [
                        "Maintained and developed the company websites created by Wordpress and Laravel.",
                        "Added newcross-browser features for Wordpress upon requests.",
                        "Previously maintained Angular based webs.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "Penbrothers (IT Serve)",
                    "position": "Frontend Web Developer",
                    "location": "Makati, Philippines",
                    "year": "November 2017 – October 2019",
                    "responsibility": [
                        "Continuously maintained and enhanced clients' websites, utilizing Laravel for ongoing development and improvement.",
                        "Worked closely with both the designer and backend team to successfully bring the website to completion.",
                        "Added new features that work well on different web browsers for both Laravel and WordPress.",
                        "Implemented mobile responsive using Bootstrap and Sass.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "Dog and Rooster Inc.",
                    "position": "Frontend Web Developer",
                    "location": "Makati, Philippines",
                    "year": "April 2017 – October 2017",
                    "responsibility": [
                        "Created projects from scratch with Wordpress and Laravel.",
                        "Maintained Wordpress and Laravel websites.",
                        "Creating and revising design mock-ups.",
                        "Implemented mobile responsive using Bootstrap and Sass.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "1Platinum Events",
                    "position": "Frontend Web Developer",
                    "location": "Remote(Freelance)",
                    "year": "February 2016 – December 2016",
                    "responsibility": [
                        "Created projects from scratch with Laravel.",
                        "Implemented mobile responsive using Bootstrap and Sass.",
                        "Worked closely with both the designer and backend team to successfully bring the website to completion.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "One Network Ecommerce",
                    "position": "Frontend Web Developer",
                    "location": "Aseana, Parañaque City, Philippines",
                    "year": "August 2015 – February 2016",
                    "responsibility": [
                        "Followed agile methods for better project efficiency.",
                        "Created projects from scratch with Laravel and AngularJS.",
                        "Implemented mobile responsive using Bootstrap and Sass.",
                        "Worked closely with both the designer and backend team to successfully bring the website to completion.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "7th Media Digital",
                    "position": "Frontend Web Developer",
                    "location": "Makati City, Philippines",
                    "year": "November 2014 – July 2015",
                    "responsibility": [
                        "Created projects from scratch with Wordpress and Laravel.",
                        "Implemented mobile responsive using Bootstrap and Sass.",
                        "Worked closely with both the designer and backend team to successfully bring the website to completion.",
                        "Utilized Git for version control and to have an organized project development."
                    ]
                },
                {
                    "company": "Conversion X",
                    "position": "Web Developer/Designer",
                    "location": "Makati City, Philippines",
                    "year": "February 2014 – August 2014",
                    "responsibility": [
                        "Created projects from scratch with Wordpress.",
                        "Redesigned Client’s websites.",
                        "Converting client’s old websites to Wordpress."
                    ]
                }
            ]
        }   
    }
}

export default data

